import { createContext } from 'react'

export type UpdateToast = {
  setMessages: (good: string[], bad: string[]) => void
}

export const UpdateToastContext = createContext<UpdateToast>({
  setMessages: () => {}
})
